export const convertToValidId = (str: string, id?: string) => {
  const trimmed = str.trim()
  const lowered = trimmed.toLowerCase()
  const dashed = lowered.replace(/ /g, "-")
  const final = id ? `${dashed}-${id}` : dashed
  return final
}

export const convertSlugToCategoryName = (str: string) => {
  const validLabel = str.replace(/-/g, " ")
  return validLabel
}

export const getCategorySlug = (category: string) =>
  category === "favorites" ? "/blog/" : `/blog/${category}/`
